var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Query } from '@core/plugin/debug/component/types';
import QueryItem from './query-item.vue';
import LoadingIndicator from './loading-indicator.vue';
var QueryBrowser = /** @class */ (function (_super) {
    __extends(QueryBrowser, _super);
    function QueryBrowser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.allQueries = [];
        _this.searchFilteredQueries = [];
        _this.queries = [];
        _this.searchText = '';
        _this.searchTextCooled = '';
        _this.searchCooldown = null;
        _this.displayMoreOffset = 0;
        _this.hasMoreQueriesToShow = false;
        _this.stats = {
            requestCount: 0,
        };
        _this.isLoading = true;
        _this.isUpdating = false;
        _this.isResetting = false;
        return _this;
    }
    QueryBrowser.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QueryBrowser.prototype.onSearchTextChanged = function () {
        var _this = this;
        window.clearTimeout(this.searchCooldown);
        this.searchCooldown = window.setTimeout(function () {
            _this.search();
        }, 500);
    };
    QueryBrowser.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true; // Cleared by this.update()
                        this.isResetting = true;
                        return [4 /*yield*/, fetch("".concat(this.endpoint, "?reset"))];
                    case 1: return [4 /*yield*/, (_a.sent()).json()];
                    case 2:
                        result = _a.sent();
                        return [4 /*yield*/, this.update()];
                    case 3:
                        _a.sent();
                        this.isResetting = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    QueryBrowser.prototype.search = function () {
        var searchText = this.searchText.toLowerCase();
        var filter = function (query) {
            return query.matches(searchText);
        };
        this.searchFilteredQueries = this.allQueries.filter(filter);
        this.searchTextCooled = this.searchText;
        this.limit();
    };
    QueryBrowser.prototype.limit = function () {
        var maxQueryCount = 32 + this.displayMoreOffset;
        this.hasMoreQueriesToShow = this.searchFilteredQueries.length > maxQueryCount;
        if (this.hasMoreQueriesToShow) {
            this.queries = this.searchFilteredQueries.slice(0, maxQueryCount);
        }
        else {
            this.queries = this.searchFilteredQueries;
        }
    };
    QueryBrowser.prototype.showMore = function () {
        this.displayMoreOffset += 32;
        this.limit();
    };
    QueryBrowser.prototype.manualUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isUpdating = true;
                        return [4 /*yield*/, this.update()];
                    case 1:
                        _a.sent();
                        this.isUpdating = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    QueryBrowser.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queries, requestCounters, _i, _a, query, requestId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, fetch(this.endpoint)];
                    case 1: return [4 /*yield*/, (_b.sent())
                            .json()];
                    case 2:
                        queries = _b.sent();
                        this.allQueries =
                            queries.map(function (o) { return Object.assign(new Query(), o); })
                                .sort(function (a, b) { return b.timestamp - a.timestamp; });
                        requestCounters = {};
                        for (_i = 0, _a = this.allQueries; _i < _a.length; _i++) {
                            query = _a[_i];
                            if (query.request_id in requestCounters) {
                                requestCounters[query.request_id]++;
                            }
                            else {
                                requestCounters[query.request_id] = 1;
                            }
                        }
                        this.stats.requestCount = 0;
                        for (requestId in requestCounters) {
                            this.stats.requestCount++;
                        }
                        this.displayMoreOffset = 0;
                        this.search();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ type: String })
    ], QueryBrowser.prototype, "endpoint", void 0);
    __decorate([
        Prop({ type: String })
    ], QueryBrowser.prototype, "requestId", void 0);
    __decorate([
        Watch('searchText')
    ], QueryBrowser.prototype, "onSearchTextChanged", null);
    QueryBrowser = __decorate([
        Component({
            components: { QueryItem: QueryItem, LoadingIndicator: LoadingIndicator }
        })
    ], QueryBrowser);
    return QueryBrowser;
}(Vue));
export default QueryBrowser;
